import { IImage } from '@models/IImage';
import { IMeta } from '@models/IMeta';
import { IWishlistDrawerLabels } from './IWishlistDrawer';
import ColourSwatchVariantEnum from './enums/ColourSwatchVariantEnum';

export const enum ColourSwatchCardBG {
  Grey = 'tw-bg-grey-10',
  White = 'tw-bg-white',
}
export interface IColourSwatchCard extends IColourSwatchGallery {
  readonly id: string;
  readonly bgColour?: ColourSwatchCardBG;
  readonly description?: string | TrustedHTML;
  readonly link?: string;
  readonly meta?: IMeta;
  readonly variant: ColourSwatchVariantEnum;
  readonly wishlistDrawerLabels?: IWishlistDrawerLabels;
}

export interface IColourSwatchGallery {
  readonly mainImage?: IImage;
  readonly colourHexCode?: string;
  readonly colourCode: string;
  readonly colourName?: string;
  readonly images: IImage[];
  readonly tag?: string;
}
